export default __webpack_public_path__ + "static/media/close-rounded.e26d583e.svg";